import LDS_IconError from './icon-error.jsx';

export default {
  LDS_IconError,
};
